import { render, staticRenderFns } from "./ProjectInteractions.vue?vue&type=template&id=f9d607b6&"
import script from "./ProjectInteractions.vue?vue&type=script&lang=js&"
export * from "./ProjectInteractions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports